// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__GrUtG","content":"Loader_content__xtQu_","loader__loader":"Loader_loader__loader__mt_LZ"};